import React, { Fragment, useMemo } from "react";

import clsx from "clsx";
import Image from "next/image";

import integrationsList from "../../../../integrations-scroller/integrations-list";
import useRandomAnimation from "../../../../integrations-scroller/use-random-animation";
import styles from "./index.module.css";

const logoImageSize = 141;

export const integrationList = [...integrationsList, "YourIntegrationHere"];

const Item = ({ breakIndices, index, integration, yOffset, xOffset }) => {
  const animationClass = useRandomAnimation(true);
  const breakIndex = breakIndices.indexOf(index);
  const addOffset = useMemo(() => {
    // Only add offset to last row
    if (index !== integrationList.length - 1) {
      return false;
    }

    // Add offset if needed so last row is not overlapping previous row
    const remainder = integrationList.length - breakIndices[breakIndices.length - 1];
    const prevRowItemsCount = integrationList.length - breakIndices[breakIndices.length - 2] - remainder;
    const prevRowEven = prevRowItemsCount % 2 === 0;
    const lastRowEven = remainder % 2 === 0;

    return (prevRowEven && lastRowEven) || (!prevRowEven && !lastRowEven);
  }, [breakIndices, index]);

  return (
    <Fragment key={integration}>
      {breakIndex > -1 && <div key={`${index}_break`} className={clsx(styles.break)} />}
      <div
        className={clsx("random-animation", styles.logo, animationClass)}
        style={{
          marginBottom: yOffset,
          marginLeft: -xOffset,
          marginRight: -xOffset,
        }}
        title={integration}
      >
        <Image
          src={`/images/logos/${integration}.svg`}
          alt={`${integration} logo`}
          height={`${logoImageSize}px`}
          width={`${logoImageSize}px`}
          layout="responsive"
        />
      </div>
      {addOffset && (
        <div
          className={styles.logo}
          style={{
            marginBottom: yOffset,
            marginLeft: -xOffset,
            marginRight: -xOffset,
          }}
        />
      )}
    </Fragment>
  );
};

export default Item;
